import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FiGrid,
  FiFileText,
  FiUsers,
  FiUser,
  FiFolder,
  FiTag,
  FiToggleRight,
  FiShield,
  FiLogOut,
  FiGlobe,
  FiX,
} from "react-icons/fi";
import { selectUser, hasPermission } from "../../store/authSlice";
import styles from "./Sidebar.module.css";
import logo from "./main-logo-w.webp";

// page key -> { label, to, icon }
const NAV_ITEMS = [
  {
    page: "dashboard",
    label: "Dashboard",
    to: "/admin/dashboard",
    icon: FiGrid,
  },
  { page: "blogs", label: "Blogs", to: "/admin/blogs", icon: FiFileText },
  {
    page: "category",
    label: "Category",
    to: "/admin/category",
    icon: FiFolder,
  },
  { page: "tags", label: "Tags", to: "/admin/tags", icon: FiTag },
  { page: "status", label: "Status", to: "/admin/status", icon: FiToggleRight },
  { page: "users", label: "Users", to: "/admin/users", icon: FiUsers },
  { page: "role", label: "Role", to: "/admin/roles", icon: FiShield },
  {
    page: "profile",
    label: "Profile Setting",
    to: "/admin/profile",
    icon: FiUser,
  },
];

export default function Sidebar({
  basePath = "admin",
  onLinkClick,
  showCloseButton = false,
  onLogout,
  onCloseSidebar,
}) {
  const user = useSelector(selectUser);

  const visibleItems = NAV_ITEMS.filter(
    (item) => item.page === "blogs" || hasPermission(user, item.page, "view"),
  );
  const scopedItems = visibleItems.map((item) => {
    const suffix = item.to.replace(/^\/admin\/?/, "/");
    return {
      ...item,
      to: `/${basePath}${suffix}`.replace(/\/+/g, "/"),
    };
  });

  const handleVisitWebsite = () => {
    window.open("/", "_blank", "noopener");
    if (onLinkClick) onLinkClick();
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarHeader}>
        <img src={logo} alt="Logo" className={styles.logo} />
        {showCloseButton && (
          <button
            type="button"
            className={styles.closeSidebarButton}
            onClick={onCloseSidebar}
          >
            <FiX size={18} />
          </button>
        )}
      </div>

      <nav className={styles.nav}>
        {scopedItems.map(({ page, label, to, icon: Icon }) => (
          <NavLink
            key={page}
            to={to}
            end={page === "dashboard"}
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.active : ""}`
            }
            onClick={onLinkClick}
          >
            <Icon className={styles.icon} /> {label}
          </NavLink>
        ))}
      </nav>

      <div className={styles.sidebarFooter}>
        <button className={styles.websiteButton} onClick={handleVisitWebsite}>
          <FiGlobe /> Visit Website
        </button>
        <button className={styles.logoutButton} onClick={onLogout}>
          <FiLogOut /> Logout
        </button>
      </div>
    </div>
  );
}
